import menu from './menu';
import notifications from './notifications';

const languages = window.env.LOCALES;

export default {
    rootPath: window.env.APP_URL,
    currentConnection: window.env.LOCALE || window.env.DEFAULT_LOCALE,
    connections: function() {
        return _.map(languages, (val, key) => {
            return {
                id: key,
                name: val.name,
                link: val.url + `/admin`,
            }
        });
    },

    cmsPath: '/admin',
    cmsTitle: window.env.APP_NAME,
    routes: {
        default: '/dashboard',
        endpoints: {
            '^/pages': {
                params: { filter: 'parent_id:$null' },
            },
            '^/panels': {
                params: { filter: 'content_id:$null' },
            },
            '^/categories': {
                params: { filter: 'parent_id:$null' },
            },
            '^/stores': {
                params: { filter: 'parent_id:$null' },
            },
            '^/orders': {
                params: { sort: 'order_date:desc' }
            },
            '^/customers': {
                params: { }
            },
            '^/enquiries': {
                params: { sort: 'created_at:desc' }
            },
            '^/subscribers': {
                params: { sort: 'created_at:desc' }
            },
            '^/downloads': {
                params: { sort: 'created_at:desc' }
            },
            '^/page/[0-9]+/files': {
                params: { sort: 'position:asc' }
            }
        }
    },
    file: {
        extensions: {
            img: ['png', 'jpg', 'jpeg', 'gif', 'svg'],
            doc: ['doc', 'docx'],
            pdf: ['pdf'],
            xls: ['xls', 'xlsx'],
            csv: ['csv'],
            mp4: ['mp4', 'webm'],
        }
    },
    menu,
    notifications,
    inboxActive: false,
}
